import formatDate from '@/services/general/formatIsoDate';

export default function preparationEnvoieAuBackOtTech(ot) {
  ot.dateSouhaitee = formatDate(ot.dateSouhaitee);
  ot.datePlanification = formatDate(ot.datePlanification);
  ot.dateRealisation = formatDate(ot.dateRealisation);
  ot.dateFacture = formatDate(ot.dateFacture);
  ot.montantHt = ot.montantHt ?? 0;
  if (ot.otStock && ot.otStock.lieuDeStockage) {
    delete ot.otStock.lieuDeStockage;
  }
  return ot;
}
